export default {
  'ReviewsFilter.positive': 'Positive',
  'ReviewsFilter.negative': 'Negative',
  'ReviewsFilter.topicsFilter': 'All topics',
}
